import React from "react";
import { useTranslation } from "react-i18next";

const CommonNotification = ({
  show,
  handleNotificationClose,
  sendNowHandler,
}) => {
  const showHideClassName = show && "user_detail_modal_show";

  const { t } = useTranslation("common");

  return (
    <>
      <div
        className={`user_detail_modal_bg  ${showHideClassName}`}
        onClick={handleNotificationClose}
      ></div>
      <section
        className={`user_detail_modal_main delete_feedback_modal ${showHideClassName}`}
      >
        <div className="inquiry_complaint_detail_section">
          <h2 className="announcement_page-view-modal">
            {t("modal.send.sendNotification")}
          </h2>
          <h4 className="announcement_page-view-modal delete_feedback_subheading">
            {t("modal.send.send_common_notification_desc")}
          </h4>
          <div className="delete_feedback_btn-container">
            <button
              type="button"
              onClick={handleNotificationClose}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn secondary_btn"
            >
              {t("common.close")}
            </button>
            <button
              type="button"
              onClick={sendNowHandler}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn ml-20"
            >
              {t("table.send")}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default CommonNotification;
